import Api from '../Jobs/API';

const EXPIRY_TIME = 3600 * 1000; // 1 hour in milliseconds

export const fetchPreferences = async (source: string) => {
  const expiryCacheKey = `userPreferences:${source}:expiry`;
  const cacheKey = `userPreferences:${source}`;

  const responseExpiryStr = localStorage.getItem(expiryCacheKey);
  const responseExpiry = responseExpiryStr ? Number(responseExpiryStr) : 0;

  if (responseExpiry > Date.now()) {
    const responseFromLocal = localStorage.getItem(cacheKey);

    if (responseFromLocal) {
      return JSON.parse(responseFromLocal);
    }
  }

  const response = await Api.getUISettings({ source });
  localStorage.setItem(cacheKey, JSON.stringify(response));
  localStorage.setItem(expiryCacheKey, (Date.now() + EXPIRY_TIME).toString());
  return response;
};

export const clearPreferenceCache = (source: string) => {
  const expiryCacheKey = `userPreferences:${source}:expiry`;
  const cacheKey = `userPreferences:${source}`;
  localStorage.removeItem(expiryCacheKey);
  localStorage.removeItem(cacheKey);
};

export const clearAllPreferenceCache = () => {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('userPreferences')) {
      localStorage.removeItem(key);
    }
  });
};

export const updateUiSettings = async (params, onError?: (message: string) => void) => { 
  const source = params.source;
  try {
    await Api.postUISettings({ ui_preference: params });
    if (source) {
      clearPreferenceCache(source);
    }
  } catch (error) {
    console.log(error);
    if (onError && error instanceof Error) {
      onError(error.message);
    }
  }
};
